export default async function getLocation (appData) {
  // return location from app data if available
  if (appData?.latitude && appData?.longitude && appData?.source) {
    return {
      latitude: appData.latitude,
      longitude: appData.longitude,
      source: appData.source
    }
  }

  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 60000
  }

  const fetchLocationFromApi = async () => {
    try {
      const response = await fetch('https://freeipapi.com/api/json/')
      const data = await response.json()

      return {
        latitude: data.latitude,
        longitude: data.longitude,
        source: 'IP'
      }
    } catch (error) {
      return {
        latitude: 0,
        longitude: 0,
        source: 'IP'
      }
    }
  }

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(pos => {
      let crd = pos.coords

      resolve({
        latitude: crd.latitude,
        longitude: crd.longitude,
        source: crd.accuracy <= 50 ? 'GPS' : 'IP'
      })
    }, async (err) => {
      const data = await fetchLocationFromApi()
      resolve(data)
    }, options)
  })
}